import React from 'react'
import TextPage from '../TextPage/TextPage'
import { withRouter } from 'react-router-dom'

function ServicePage({ ...router }) {
  console.log('🚀 ~ ServicePage ~ router:', router)
  const serviceId = router.match.params.id

  return <TextPage path={'services'} docId={serviceId} />
}

export default withRouter(ServicePage)
